import { Button } from "../../shared";
import { Box, Modal, ModalDialog, ModalClose, DialogTitle, DialogContent, Typography } from "@mui/joy";
import { Trash2 } from "lucide-react";

interface ImageWithMetadata {
    url: string;
    assetId?: string;
    note?: string | null;
}

export function ImagePreviewModal({ image, onClose }: { image: ImageWithMetadata | null; onClose: () => void }) {
    const imageUrl = image?.url || null;
    const note = image?.note || null;

    return (
        <Modal open={!!imageUrl} onClose={onClose}>
            <ModalDialog
                layout="center"
                variant="soft"
                sx={{
                    maxWidth: "90vw",
                    maxHeight: "90vh",
                    width: "auto",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                }}
            >
                <ModalClose onClick={onClose} />
                <DialogTitle sx={{ pb: 1 }}>Image Preview</DialogTitle>
                <DialogContent
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 2,
                        overflow: "auto",
                        p: 2,
                    }}
                >
                    {imageUrl && (
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                maxWidth: "100%",
                                maxHeight: "70vh",
                                overflow: "auto",
                            }}
                        >
                            <img
                                src={imageUrl}
                                alt="Preview"
                                style={{
                                    maxWidth: "100%",
                                    maxHeight: "70vh",
                                    height: "auto",
                                    width: "auto",
                                    borderRadius: 8,
                                    objectFit: "contain",
                                }}
                            />
                        </Box>
                    )}

                    {note && (
                        <Box
                            sx={{
                                width: "100%",
                                p: 2,
                                bgcolor: "background.surface",
                                borderRadius: "md",
                                border: "1px solid",
                                borderColor: "divider",
                            }}
                        >
                            <Typography level="title-sm" sx={{ mb: 1, fontWeight: 600 }}>
                                Caption
                            </Typography>
                            <Typography level="body-sm" sx={{ color: "text.secondary" }}>
                                {note}
                            </Typography>
                        </Box>
                    )}

                    <Box
                        display={"flex"}
                        gap={1}
                        justifyContent={"flex-end"}
                        alignItems={"center"}
                        sx={{ width: "100%", pt: 1 }}
                    >
                        <Button color={"danger"} variant={"soft"} size="sm" startDecorator={<Trash2 size={16} />}>
                            Delete
                        </Button>
                    </Box>
                </DialogContent>
            </ModalDialog>
        </Modal>
    );
}
